/* @flow strict */

export const columns = (): [] => {
    return [
      {
          selector: 'first_name',
          name: 'First Name',
          sortable: true
      },
      {
          selector: 'last_name',
          name: 'Last Name',
          sortable: true
      },
      {
          selector: 'email_address',
          name: 'Email',
          sortable: true
      },
      {
          selector: 'phone_number',
          name: 'Phone',
          sortable: true
      },
      {
          selector: 'remark',
          name: 'Notes',
          sortable: true
      },
      {
        selector: 'birth_year',
        name: 'Birth',
        cell: (row: {}): React.Element => {
            if (row.birth_day && row.birth_month) {
                return `${row.birth_month}/${row.birth_day}/${row.birth_year}`;
            }
            return (
                row.birth_year
            );
        },
        sortable: true
      }
    ];
  };
